import React, { useEffect, useState } from "react";
import {
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Grid,
  GridComponent,
  Inject,
  Search,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import { Button, Form, Input, message, Modal, Space, Spin } from "antd";
import axios from "axios";

const { TextArea } = Input;

const GridSupplier = (props) => {
  let baseUrl = props.baseUrl;
  let grid: Grid | null;
  const [form] = Form.useForm();
  const [formUpdate] = Form.useForm();

  const [isLoading, setisLoading] = useState(true);
  const [data, setData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalUpdateVisible, setIsModalUpdateVisible] = useState(false);
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);
  const [recordId, setRecordId] = useState();
  const [isSave, setIsSave] = useState(false);
  const [isClick, setIsClick] = useState(false);

  //mengambil data caddy
  useEffect(() => {
    let isMounted = true;

    axios
      .get(baseUrl + "/supplier")
      .then((res) => {
        if (isMounted) {
          setisLoading(false);
          setData(res.data);
        }
      })
      .catch((err) => {
        setisLoading(false);
        console.log(err);
      });

    return () => {
      isMounted = false;
    };
  }, [data]);

  const toolbarku = [
    {
      text: "Add",
      // tooltipText: "Tambah Kapal",
      prefixIcon: "e-add",
      id: "addButton",
    },
    {
      text: "Edit",
      // tooltipText: "Ubah Kapal",
      prefixIcon: "e-edit",
      id: "editButton",
    },
    {
      text: "Delete",
      // tooltipText: "Hapus Kapal",
      prefixIcon: "e-delete",
      id: "deleteButton",
    },
    "Search",
  ];

  const toolbarClick = (args) => {
    if (grid) {
      if (args.item.id === "addButton") {
        // console.log("tombol add");
        setIsModalVisible(true);
      } else if (args.item.id === "editButton") {
        // console.log("tombol edit");
        setIsModalUpdateVisible(true);
      } else if (args.item.id === "deleteButton") {
        // console.log("tombol delete");
        if (data.length > 0) {
          setIsModalDeleteVisible(true);
        } else {
          message.warning("No record to delete");
        }
      }
    }
  };

  const rowSelected = () => {
    if (grid) {
      let record = grid.getSelectedRecords()[0];
      // console.log(record);
      setRecordId(record.id);
      formUpdate.setFieldsValue({
        id: record.id,
        kd_supplier: record.kd_supplier,
        nm_supplier: record.nm_supplier,
        alamat: record.alamat,
        no_telp: record.no_telp,
        person: record.person,
      });
    }
  };

  const onFinish = (v) => {
    setIsSave(true);
    let data = {
      kd_supplier: v.kd_supplier,
      nm_supplier: v.nm_supplier,
      alamat: v.alamat,
      no_telp: v.no_telp,
      person: v.person,
      user_id: localStorage.getItem("id"),
    };

    axios
      .post(baseUrl + "/supplier", data)
      .then(() => {
        console.log("berhasil menambah data");
        message.success("Berhasil menambah data");
        setIsSave(false);
        setIsModalVisible(false);
        form.resetFields();
      })
      .catch((e) => {
        console.log("gagal menambah data");
        message.error(e.message);
        setIsSave(false);
        setIsModalVisible(false);
      });
  };

  const onFinishFailed = (v) => {
    console.log(v);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsModalDeleteVisible(false);
    setIsModalUpdateVisible(false);
    form.resetFields();
    formUpdate.resetFields();
  };

  const onFinishUpdate = (v) => {
    setIsSave(true);
    let data = {
      kd_supplier: v.kd_supplier,
      nm_supplier: v.nm_supplier,
      alamat: v.alamat,
      no_telp: v.no_telp,
      person: v.person,
      user_id: localStorage.getItem("id"),
    };

    axios
      .put(baseUrl + `/supplier/${recordId}`, data)
      .then(() => {
        console.log("berhasil merubah data");
        message.success("Berhasil merubah data");
        setIsSave(false);
        setIsModalUpdateVisible(false);
        formUpdate.resetFields();
      })
      .catch((e) => {
        console.log("gagal merubah data");
        message.error(e.message);
        setIsSave(false);
        setIsModalVisible(false);
      });
  };

  const handleOkDelete = () => {
    setIsClick(true);
    axios
      .delete(baseUrl + `/supplier/${recordId}`)
      .then((res) => {
        message.success("Data berhasil dihapus !");
        setIsClick(false);
        setIsModalDeleteVisible(false);
      })
      .catch((err) => {
        message.error("Gagal menghapus data !");
        setIsClick(false);
        setIsModalDeleteVisible(false);
      });
  };

  if (isLoading) {
    return (
      <div className="example">
        <Spin />
      </div>
    );
  } else {
    return (
      <div>
        <GridComponent
          dataSource={data}
          rowHeight="30"
          height="200px"
          ref={(g) => (grid = g)}
          toolbar={toolbarku}
          toolbarClick={toolbarClick}
          rowSelected={rowSelected}
        >
          <ColumnsDirective>
            <ColumnDirective
              field="id"
              headerText="ID"
              // textAlign="center"
              width="100"
            />

            <ColumnDirective
              field="kd_supplier"
              headerText="CODE SUPPLIER"
              // textAlign="center"
              width="100"
            />
            <ColumnDirective
              field="nm_supplier"
              headerText="NAMA SUPPLIER"
              // textAlign="center"
              width="200"
            />
            <ColumnDirective
              field="alamat"
              headerText="ALAMAT"
              // textAlign="center"
              width="200"
            />
            <ColumnDirective
              field="no_telp"
              headerText="NO.TELP"
              // textAlign="center"
              width="120"
            />
            <ColumnDirective
              field="person"
              headerText="SALES"
              // textAlign="center"
              width="120"
            />
            <ColumnDirective
              field="user_id"
              headerText="USER ID"
              // textAlign="center"
              width="120"
            />
            {/* <ColumnDirective
              field="updator"
              headerText="UPDATOR"
              // textAlign="center"
              width="120"
            /> */}
          </ColumnsDirective>
          <Inject services={[Search, Toolbar, CommandColumn]} />
        </GridComponent>

        {/* MODAL */}
        <Modal
          title="Input Supplier"
          visible={isModalVisible}
          onCancel={() => {
            setIsModalVisible(false);
          }}
          footer={null}
          //   closable={false}
        >
          <Form
            form={form}
            name="basic"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 20 }}
            // initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            // autoComplete="off"
            // initialValues={{ nm_poli: props.poli }}
          >
            <Form.Item
              wrapperCol={{ span: 6 }}
              label="Kode Supplier"
              name="kd_supplier"
              rules={[{ required: true, message: "Masukkan kode supplier !" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Nama Supplier"
              name="nm_supplier"
              rules={[{ required: true, message: "Masukkan nama supplier !" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Alamat"
              name="alamat"
              // rules={[{ required: true, message: "Masukkan nama supplier !" }]}
            >
              <TextArea rows={3} />
            </Form.Item>

            <Form.Item
              wrapperCol={{ span: 10 }}
              label="No.Telp"
              name="no_telp"
              // rules={[{ required: true, message: "Masukkan nama supplier !" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              wrapperCol={{ span: 10 }}
              label="Sales"
              name="person"
              // rules={[{ required: true, message: "Masukkan nama supplier !" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 6, span: 20 }}>
              <Space>
                <Button type="default" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button type="primary" htmlType="submit" loading={isSave}>
                  Save
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
        {/* END MODAL */}

        {/* MODAL DELETE */}
        <Modal
          title="Confirmation Delete"
          visible={isModalDeleteVisible}
          onOk={handleOkDelete}
          onCancel={handleCancel}
          confirmLoading={isClick}
          width={300}
        >
          <p>Yakin data akan dihapus ?</p>
        </Modal>
        {/* END MODAL DELETE */}

        {/* MODAL UPDATE */}
        <Modal
          title="Update Supplier"
          visible={isModalUpdateVisible}
          onCancel={() => {
            setIsModalUpdateVisible(false);
          }}
          footer={null}
          //   closable={false}
        >
          <Form
            form={formUpdate}
            name="basic-update"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 20 }}
            // initialValues={{ remember: true }}
            onFinish={onFinishUpdate}
            onFinishFailed={onFinishFailed}
            // autoComplete="off"
            // initialValues={{ nm_poli: props.poli }}
          >
            <Form.Item
              hidden
              wrapperCol={{ span: 6 }}
              label="id"
              name="id"
              // rules={[{ required: true, message: "Masukkan kode supplier !" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              wrapperCol={{ span: 6 }}
              label="Kode Supplier"
              name="kd_supplier"
              rules={[{ required: true, message: "Masukkan kode supplier !" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Nama Supplier"
              name="nm_supplier"
              rules={[{ required: true, message: "Masukkan nama supplier !" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Alamat"
              name="alamat"
              // rules={[{ required: true, message: "Masukkan nama supplier !" }]}
            >
              <TextArea rows={3} />
            </Form.Item>

            <Form.Item
              wrapperCol={{ span: 10 }}
              label="No.Telp"
              name="no_telp"
              // rules={[{ required: true, message: "Masukkan nama supplier !" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              wrapperCol={{ span: 10 }}
              label="Sales"
              name="person"
              // rules={[{ required: true, message: "Masukkan nama supplier !" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 6, span: 20 }}>
              <Space>
                <Button type="default" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button type="primary" htmlType="submit" loading={isSave}>
                  Update
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
        {/* END MODAL UPDATE*/}
      </div>
    );
  }
};

export default GridSupplier;
